module.exports = __webpack_public_path__ + "img/knowledge.b48d3188.png";